import request from '@/utils/request'

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return request({
    url: '/system/dict/data/showType/' + dictType,
    method: 'get'
  })
}

// 获取校区字段
export function getSchoolDicts() {
  return request({
    url: '/basedata/school/dictList',
    method: 'get'
  })
}